export function findLastIndexWhichContainsChildren(arr) {
    let lastIndexWithChildren = -1;
    for (let i = 1; i < arr.length; i++) {
        if (arr[i].children) {
            lastIndexWithChildren = i;
        }
    }
    return lastIndexWithChildren;
}
export function pushStepIntoSpecificIndex(arr, index, value) {
    arr.splice(index, 0, value);
}
export function updateCommentSteps(comment, isInitialize, uploadedFilesOverride) {
    try {
        const _selectedStep = [...this.writtenSteps, ...this.oralSteps, ...this.statusList].find(x => x.id === comment.status);
        let step = this.steps.find(x => (x.statusId && x.statusId === comment.status) || (x.label && _selectedStep && x.label === _selectedStep.value));

        const getUploadedFiles = () => {
            const src = uploadedFilesOverride || this.uploadedFile || [];
            return src.map(file => ({
                id: file.id,
                name: file.name,
                fileURL: file.fileURL
            }));
        };

        const buildChild = () => ({
            _expanded: false,
            _editing: false,
            created_at: comment.created_at,
            id: comment.id,
            action_comment: comment.action_comment,
            include_in_report: comment.include_in_report,
            type: comment.status,
            label: comment.action_comment,
            statusable_id: comment.statusable_id,
            statusable_type: comment.statusable_type,
            screening_endorsement: comment.screening_endorsement ?? {},
            applicant_files: isInitialize
                ? (comment.applicant_files || []).map(x => ({
                    id: x.id,
                    name: x.file_name,
                    fileURL: x.file_path
                }))
                : getUploadedFiles()
        });

        if (!step) {
            if (_selectedStep !== undefined) {
                const obj = {
                    label: _selectedStep.value,
                    statusId: comment.status,
                    index: this.steps.length,
                    showButtons: true,
                    children: [buildChild()]
                };
                pushStepIntoSpecificIndex(this.steps, 0, obj);
            }
        } else {
            // Update existing child or push as new one within the same status group
            const existingChild = step.children.find(c => c.id === comment.id);
            if (existingChild) {
                existingChild.action_comment = comment.action_comment;
                existingChild.label = comment.action_comment;
                existingChild.created_at = comment.created_at || existingChild.created_at;
                if (!isInitialize) {
                    const files = getUploadedFiles();
                    if (files.length > 0) {
                        existingChild.applicant_files = files;
                    }
                }
            } else {
                step.children.push(buildChild());
            }
        }
    } catch (exception) {
        console.error(exception)
    }
}
